import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { CartDrawer } from './app/components/CartDrawer';
import { AuthProvider } from './context/AuthContext';
import AuthBar from './app/components/AuthBar';
import { LoLAContextProvider } from '@nicherest/lola/training/LoLAContext';
import { ThemeProvider as VendorThemeProvider } from './app/modules/businesses/themes/craft-fair-vendor/components/ThemeContext';
import VendorBusinessPage from './app/modules/businesses/themes/craft-fair-vendor/templates/CraftFairVendorPage';
import { CartPage } from './app/pages/CartPage';
import { CheckoutPage } from './app/pages/CheckoutPage';
import LoginPage from './app/pages/LoginPage';
import './posthog';

/**
 * Minimal client app. Pages are served as STATIC HTML by the server (home, vendor pages);
 * React only hydrates the interactive bits onto them: the vendor storefront (cart) and the
 * cart/checkout pages.
 *
 * The vendor being hydrated is whatever the server/generator baked into the static page â€”
 * window.__APP_SLUG__ + window.__INITIAL_DATA__. NO hardcoded vendor names or domains:
 * a new vendor is a data operation (a DB row + a generated page), never a code change.
 */
const slug: string | null = (window as any).__APP_SLUG__ || null;

function RedirectToServer() {
  if (window.location.port === '3000') {
    window.location.replace(window.location.href.replace(':3000', ':3001'));
  }
  return null;
}
const geo = (window as any).__INITIAL_DATA__?.geo;

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <LoLAContextProvider>
          <VendorThemeProvider>
            <Router>
              <AuthBar />
              <CartDrawer />
            <Routes>
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/auth/login" element={<LoginPage />} />
              {/* Any other path: hydrate the vendor storefront for the injected slug. */}
              <Route
                path="*"
                element={slug ? <VendorBusinessPage businessName={slug} geo={geo} /> : <RedirectToServer />}
              />
            </Routes>
          </Router>
        </VendorThemeProvider>
      </LoLAContextProvider>
    </CartProvider>
  </AuthProvider>
  );
}

export default App;
